import VisitsPage from "@/pages/portal/VisitsPage";
import InstallationsPage from "@/pages/portal/InstallationsPage";

export default function SchedulePage() {
  return (
    <div data-testid="schedule-page" className="space-y-10">
      <section>
        <h2 className="font-serif text-xl text-navy-900 mb-4">Home Visits</h2>
        <VisitsPage />
      </section>
      <section>
        <h2 className="font-serif text-xl text-navy-900 mb-4">Installations</h2>
        <InstallationsPage />
      </section>
    </div>
  );
}
